import React from "react";
import { PaymentPage } from "../features/payment/component/Payment";
import { Navbar } from "../features/navigation/components/Navbar";
import { Footer } from "../features/footer/Footer";

export const PaymentPage1 = () => {
  return (
    <>
      <Navbar />
      <PaymentPage />
      <Footer />
    </>
  );
};
